import { pageIdFromPath } from '~~/layers/config/shared/utils/page-registry';

/**
 * Emits one navigation breadcrumb per confirmed route change and stamps
 * `ctx.route`/`ctx.feature` on the ambient logger so every subsequent log carries
 * the current journey position. Runs after 000.frogger-root.client.ts has stamped
 * base context. `feature` is always `string | null` (never undefined) so an
 * unregistered page clears any stale feature from the prior route.
 */
export default defineNuxtPlugin({
	name: 'frogger-navigation',
	setup() {
		const router = useRouter();
		router.afterEach((to) => {
			const feature = pageIdFromPath(to.path); // string | null
			frogger.addContext({ route: to.path, feature });
			frogger.info('navigation', { route: to.path, feature });
		});
	},
});
